import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "./MyButton";
import Grid from "@material-ui/core/Grid";
import Moment from "react-moment";
import MaxWidthDialog from "./TestDialog";
import SuKienChiTietDialog from "./SuKienChiTietDialog";
import Container from "@material-ui/core/Container";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import TrucBanTimKiemControl from "./controls/TrucBanTimKiemControl";
import TrucBanDenEditDialog from "./TrucBanDenEditDialog";
import TrucBanDiEditDialog from "./TrucBanDiEditDialog";

const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");
const PhuongThucGui = ["Khác", "Thoại", "Fax", "Email"];
const columns = [
  { field: "id", headerName: "STT", width: 70 },
  { field: "TrucBanID", headerName: "Mã số", width: 80 },
  {
    field: "ChieuDen",
    headerName: "Chiều",
    width: 130,
    renderCell: (params) => {
      return params.getValue("ChieuDen") === true ? "Đến" : "Đi";
    },
  },
  {
    field: "TenNoiGui",
    headerName: "Nơi gửi",
    width: 230,
    renderCell: (params) =>
      params.getValue("ChieuDen") === true
        ? params.getValue("TenNoiGui")
        : params.getValue("TenCoQuan"),
  },
  {
    field: "TenNoiNhan",
    headerName: "Nơi nhận",
    width: 230,
    renderCell: (params) =>
      params.getValue("ChieuDen") === true
        ? params.getValue("TenCoQuan")
        : params.getValue("TenNoiNhan"),
  },

  {
    field: "ThoiGian",
    headerName: "Thời gian",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy HH:mm">{params.getValue("ThoiGian")}</Moment>
    ),
  },
  {
    field: "PhuongThuc",
    headerName: "Phương thức",
    width: 130,
    renderCell: (params) => PhuongThucGui[params.getValue("PhuongThuc")],
  },
  { field: "TenSK", headerName: "Sự kiện liên quan", width: 230 },
  { field: "NoiDung", headerName: "Nội dung", width: 200 },

  { field: "NguoiCN", headerName: "Người CN", width: 120 },
  {
    field: "NgayCN",
    headerName: "Ngày CN",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy HH:mm">{params.getValue("NgayCN")}</Moment>
    ),
  },
];

class TrucBanPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi
      open_den_sukien: false, //hien thi form nhap moi su kien
      open_di_sukien: false,
      open_chitiet_sukien: false,
      open_edit_sukien: false, //hien thi form edit su kien
      Editting_TrucBanID: undefined,
      Editting_ChieuDen: false,
      showConfirmXoa: false,
    };
  }

  popupComp = undefined;

  componentDidMount() {}
  //call khi user thay doi trang
  handlePageChange = (params) => {
    if (this.callbackSearch) {
      this.callbackSearch(params.page);
    }
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Box display="flex">
            <TrucBanTimKiemControl
              onSearched={(dieukien, data) => {
                var total = data.total;
                console.log("ket qua", dieukien);
                data.danhsach.map((item, index) => {
                  item.id = index + 1 + (dieukien.Page - 1) * dieukien.PageSize;
                });
                var search = {};
                Object.assign(search, dieukien);
                this.setState({
                  search: search,
                  dataRows: data.danhsach,
                  totalRows: data.total,
                });
              }}
              callback={(func) => (this.callbackSearch = func)}
            />
          </Box>
          <Box flexGrow={1}>
            <DataGrid
              rows={this.state.dataRows}
              columns={columns}
              id="TrucBanID"
              autoHeight
              rowHeight={32}
              className={classes.gridContainer}
              pagination
              pageSize={this.state.search.PageSize}
              rowCount={this.state.totalRows}
              paginationMode="server"
              sortingMode="server"
              menuContainerStyle={{ zIndex: 999 }}
              onPageChange={this.handlePageChange}
              onCellClick={(params) => {
                console.log(params);
                this.setState({
                  Editting_TrucBanID: params.data.TrucBanID,
                  Editting_ChieuDen: params.data.ChieuDen,
                });
              }}
            />
          </Box>
          <Box alignSelf="flex-start" display="flex">
            <IconLabelButton
              variant="contained"
              color="primary"
              size="normal"
              disabled={!global.User.Quyen.R241}
              icon={<AddCircleIcon />}
              text={"Thông tin đến"}
              onClick={() => {
                this.setState({ open_den_sukien: true });
              }}
            />
            <IconLabelButton
              variant="contained"
              color="primary"
              size="normal"
              disabled={!global.User.Quyen.R241}
              icon={<AddCircleIcon />}
              text={"Thông tin đi"}
              onClick={() => {
                this.setState({ open_di_sukien: true });
              }}
            />
            <IconLabelButton
              variant="contained"
              color="primary"
              size="normal"
              icon={<EditIcon />}
              disabled={
                this.state.Editting_TrucBanID === undefined ||
                !global.User.Quyen.R241
              }
              text={"Sửa"}
              onClick={() => {
                this.setState({
                  open_edit_sukien: true,
                  showConfirmXoa: false,
                });
              }}
            />
            <IconLabelButton
              variant="contained"
              color="primary"
              size="normal"
              icon={<DeleteIcon />}
              text={"Xóa"}
              disabled={
                this.state.Editting_TrucBanID === undefined ||
                !global.User.Quyen.R241
              }
              onClick={() => {
                this.setState({ open_edit_sukien: true, showConfirmXoa: true });
              }}
            />
          </Box>
          {this.state.open_den_sukien ? (
            <TrucBanDenEditDialog
              visible={this.state.open_den_sukien}
              fullWidth={true}
              maxWidth={"sm"}
              onClose={() => this.setState({ open_den_sukien: false })}
            />
          ) : null}
          {this.state.open_di_sukien ? (
            <TrucBanDiEditDialog
              visible={this.state.open_di_sukien}
              fullWidth={true}
              maxWidth={"sm"}
              onClose={() => this.setState({ open_di_sukien: false })}
            />
          ) : null}

          {this.state.open_edit_sukien ? (
            this.state.Editting_ChieuDen ? (
              <TrucBanDenEditDialog
                visible={this.state.open_edit_sukien}
                fullWidth={true}
                maxWidth={"sm"}
                TrucBanID={this.state.Editting_TrucBanID}
                EditMode={this.state.showConfirmXoa ? "xoa" : "edit"}
                onClose={() =>
                  this.setState({
                    open_edit_sukien: false,
                    Editting_TrucBanID: undefined,
                  })
                }
              />
            ) : (
              <TrucBanDiEditDialog
                visible={this.state.open_edit_sukien}
                fullWidth={true}
                maxWidth={"sm"}
                TrucBanID={this.state.Editting_TrucBanID}
                EditMode={this.state.showConfirmXoa ? "xoa" : "edit"}
                onClose={() =>
                  this.setState({
                    open_edit_sukien: false,
                    Editting_TrucBanID: undefined,
                  })
                }
              />
            )
          ) : null}
          {this.state.open_chitiet_sukien ? (
            <SuKienChiTietDialog
              visible={this.state.open_chitiet_sukien}
              fullWidth={true}
              maxWidth={"sm"}
              onClose={() => this.setState({ open_chitiet_sukien: false })}
            />
          ) : null}
      </>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  gridContainer: {
    height: "10vh",
  },
});

export default withStyles(styles, { withTheme: true })(TrucBanPage);
